import { requestData } from '@/api/apiRequest';
import type { FeatureFlagsResponse, UpdateFeatureFlagsPayload } from '@/api/apiTypes';

export async function getTenantFeatureFlags(tenantId: number) {
  return requestData<FeatureFlagsResponse>({
    url: `feature-flags/${tenantId}/`,
  });
}

export async function updateTenantFeatureFlags(tenantId: number, payload: UpdateFeatureFlagsPayload) {
  return requestData<FeatureFlagsResponse, UpdateFeatureFlagsPayload>({
    url: `feature-flags/${tenantId}/`,
    method: 'patch',
    data: payload,
  });
}
